export type VerifyUiState =
	| { type: "waiting" }
	| { type: "consuming" }
	| { type: "synced" }
	| { type: "expired" }
	| { type: "timeout" };

type GetVerifyUiStateOptions = {
	/** Whether Clerk's session params are present in this document's URL (this tab followed the magic link). */
	hasSessionInUrl: boolean;
	isWeb: boolean;
	isSignedIn: boolean;
	userLogicalId: string | undefined;
	status: string | undefined;
	hasTimedOut: boolean;
};

export const getVerifyUiState = ({
	hasSessionInUrl,
	isWeb,
	isSignedIn,
	userLogicalId,
	status,
	hasTimedOut,
}: GetVerifyUiStateOptions): VerifyUiState => {
	if (isSignedIn && userLogicalId) {
		return hasSessionInUrl || !isWeb
			? { type: "consuming" }
			: { type: "synced" };
	}

	if (isSignedIn && hasTimedOut && !userLogicalId) {
		return { type: "timeout" };
	}

	if (status === "expired") {
		return { type: "expired" };
	}

	return { type: "waiting" };
};
